<!-- 配送车辆证照操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="100px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :disabled="dataActionBox.actionType>1" :show-message="false">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []">
                        <!-- 系统字段 -->
                        <div v-if="formOneValue.isReserved == 0">
                          <el-tooltip v-if="formOneValue.entityField == 'opmName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input  v-model.trim="sendDataInfo.opmName" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField)" :disabled="formOneValue.isChange==0" clearable>
                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                          </el-input>
                          </el-tooltip>
                          <el-tooltip v-else-if="formOneValue.entityField == 'vmLicensecode'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input  v-model.trim="sendDataInfo.vmLicensecode" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField)" :disabled="formOneValue.isChange==0" clearable>
                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                          </el-input>
                          </el-tooltip>
                          <df-date :isdisabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                          <el-select v-else-if="formOneValue.entityField == 'vcMeasures'" filterable :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]">
                            <el-option v-for="(values,keys) in dictionariesData" :key="keys" :label="values.diName" :value="values.diValue">
                            </el-option>
                          </el-select>
                          <el-input v-else-if="formOneValue.entityField == 'vcRemark'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable>
                          </el-input>
                          <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                        <!-- 扩展字段 -->
                        <div v-if="formOneValue.isReserved == 1">

                          <!-- 自填 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                          <!-- 选择数据来源 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div class="foots">
          <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
          <el-button type="primary" @click="initActionBox" v-if="dataActionBox.actionType!=2">取消</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :parentSearchData="parentSearchData" :id="seId" @TranData="changeInputModel" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "vehicleCuringAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      isLoaded: false,
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        opmId: "", //	司机ID
        opmName: "", //	司机名称
        vcCost: "", //	保养金额
        vcInstitution: "", //	保养机构
        vcMeasures: "", //	保养项目
        vcRemark: "", //	备注
        vcTime: "", //	保养时间
        vmId: "", //	车辆ID
        vmLicensecode: "", //	车牌号
      },
      parentSearchData: {},
      dictionariesData: [], //单位类型
      DialogVisible: false,
      seTitle: "",
      seWidth: "",
      seType: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //检索方案
    openSearch(sId, type) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seType = type;
      this.parentSearchData[type] = this.sendDataInfo[type]
      if (type == "opmId") {
        this.parentSearchData.opmName = this.sendDataInfo.opmName;
      } else if (type == "vmLicensecode") {
        this.parentSearchData.vmLicensecode = this.sendDataInfo.vmLicensecode;
      }
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.seType == "opmName") {
          console.log(val);
          this.sendDataInfo.opmId = val.opmId;
          this.sendDataInfo.opmName = val.opmName;
        } else if (this.seType == "vmLicensecode") {
          this.sendDataInfo.vmId = val.vmId;
          this.sendDataInfo.vmLicensecode = val.vmLicensecode;
        }
      }
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },

    //保存
    async sendDataAction() {
      let flag = false;
      this.$refs["sendDataInfo"].validate((valid) => {
        if (valid) {
        } else {
          this.$message({
            message: "请完善证照信息表单的必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
      this.sendDataInfo.uploadVoList = this.uploadVoList;
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      let responseData;

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.vehicleCuringadd(sendData);
      } else if (this.dataActionBox.actionType == 1) {
        responseData = await this.$http.vehicleCuringmodify(sendData);
      }
      if (responseData.status == 200) {
        // this.dataActionBox.showStatus = false
        this.$emit("drawerCancel");
        this.$refs["sendDataInfo"].resetFields();
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消新增
    initActionBox() {
      if (this.dataActionBox.actionType == 5) return this.$emit("drawerCancel");
      this.$emit("drawerCancel");
      this.init();
      this.$refs["sendDataInfo"].resetFields();
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        if (
          key == "supaddresses" ||
          key == "supbankinfos" ||
          key == "suplicencelinfos" ||
          key == "smManrange" ||
          key == "smProrange" ||
          key == "smTrerange"
        ) {
          this.sendDataInfo[key] = [];
        } else if (key == "supfinancelinfos") {
          for (const item in this.sendDataInfo[key]) {
            this.sendDataInfo[key][item] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.dataActionBox.boxTitle = "";
    },

    //父级传入 获取列表
    openBox() {
      //   console.log("===", this.actionData);
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      this.init();
      this.dataActionBox.showStatus = true;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增保养记录";
        this.dataActionBox.openMode = "ltr";
      } else {
        if (this.dataActionBox.actionType == 1) {
          this.dataActionBox.boxTitle = "修改保养记录";
          this.dataActionBox.openMode = "rtl";
          this.sendDataInfo = oldData;
        } else if (this.dataActionBox.actionType == 2) {
          this.dataActionBox.boxTitle = "查看信息";
          var dataInfo = JSON.parse(JSON.stringify(oldData));
          for (let key in dataInfo) {
            this.sendDataInfo[key] = dataInfo[key];
            if (
              key == "smManrange" ||
              key == "smProrange" ||
              key == "smTrerange"
            ) {
              this.sendDataInfo[key] = dataInfo[key] ? dataInfo[key].toString() : ""
            }
          }
        } else {
          this.sendDataInfo = oldData;
          this.dataActionBox.boxTitle = "证照信息审核";
        }
        this.sendDataInfo.smIntype = Number(oldData.smIntype);
      }
    },
    //获取单位类型
    async getCateDictionariesDatas() {
      let responseData = await this.$http.getCateDictionariesData({
        ids: [33],
      });
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取所有可用库房列表
    async getAllStorageRoom() {
      let responseData = await this.$http.getAllStorageRoom();
      if (responseData.status == 200) {
        this.storageRoomList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //获取生产/经营范围
    async getQueryScopeByType(type) {
      let ormId = sessionStorage.getItem('ormId')
      let params = {
        type: type,
        ormId: ormId
      }
      //type 范围类型0.生产范围1.经营范围2.诊疗
      let responseData = await this.$http.queryScopeByType(params);
      if (responseData.status == 200) {
        return responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
        return [];
      }
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.isLoaded = true;
    });
    this.getCateDictionariesDatas(); //单位类型
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
